import React from "react";
import { motion } from "framer-motion";
import { Linkedin, Instagram, Crown } from "lucide-react";
import { TEAM } from "@/data/site";
import { SectionHeading } from "@/components/pp/Shared";

const initials = (name) => name.split(" ").map((w) => w[0]).slice(0, 2).join("");
const GRADS = [
  "linear-gradient(135deg,#f59e0b,#ec4899)", "linear-gradient(135deg,#8b5cf6,#3b82f6)",
  "linear-gradient(135deg,#06b6d4,#8b5cf6)", "linear-gradient(135deg,#ec4899,#f59e0b)",
];

export default function Team() {
  return (
    <section id="team" className="relative py-24 md:py-32 bg-[#050507]" data-testid="team">
      <div className="pp-container">
        <SectionHeading overline="The Team" title="Meet the Minds Behind Your Brand" testid="team-heading" />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {TEAM.map((m, i) => (
            <motion.div key={m.role + i}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 5) * 0.05 }}
              className={`group pp-card rounded-2xl p-5 flex flex-col ${m.lead ? "ring-1 ring-[#f59e0b]/40" : ""}`}
              data-testid={`team-${m.role.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}-${i}`}
            >
              <div className="relative aspect-square rounded-xl grid place-items-center overflow-hidden mb-4"
                style={{ background: GRADS[i % GRADS.length] }}>
                <span className="font-display text-4xl md:text-5xl text-black/70">{initials(m.name)}</span>
                {m.lead && <Crown size={16} className="absolute top-2 right-2 text-black/70" />}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
              </div>
              {m.lead && <span className="pp-overline mb-1">{m.role}</span>}
              <h3 className={`font-display uppercase ${m.lead ? "text-lg text-white" : "text-sm text-white/90"} leading-tight`}>{m.name}</h3>
              {!m.lead && <p className="text-xs text-slate-400 mt-0.5">{m.role}</p>}
              <p className="text-xs text-slate-500 mt-2 leading-relaxed line-clamp-2">{m.bio}</p>
              <div className="mt-3 flex gap-2">
                <a href="#" aria-label="LinkedIn" className="h-7 w-7 grid place-items-center rounded-full bg-white/5 text-slate-400 hover:text-white transition-colors"><Linkedin size={13} /></a>
                <a href="#" aria-label="Instagram" className="h-7 w-7 grid place-items-center rounded-full bg-white/5 text-slate-400 hover:text-white transition-colors"><Instagram size={13} /></a>
              </div>
            </motion.div>
          ))}
        </div>
        <p className="mt-6 text-[11px] uppercase tracking-widest text-slate-600">Bios & social links are editable placeholders.</p>
      </div>
    </section>
  );
}
